import { render, staticRenderFns } from "./ClariveinPage.vue?vue&type=template&id=a046b986&scoped=true"
import script from "./ClariveinPage.vue?vue&type=script&lang=js"
export * from "./ClariveinPage.vue?vue&type=script&lang=js"
import style0 from "./ClariveinPage.vue?vue&type=style&index=0&id=a046b986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a046b986",
  null
  
)

export default component.exports